module.exports = "build/assets/rightWhisp.0fbfb7f0.png";